import { createSlice } from '@reduxjs/toolkit'

export const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    fullName: 'Cyril M Gupta',
    files: [],
    phone: '+00-35353673456',
    email: 'example@gmail.com',
    website: 'www.teknikforce.com',
    company: 'Teknikforce Ventures LLC',
    job: 'CEO',
    isHideAddress: true,
    fontFamily: 'Arial, sans-serif',
    cardColor: '#ffffff',
    nameColor: '#000000',
    jobCompanyColor: '#000000',
    contactDivBgColor: '#eaedff',
    contactHeadingColor: '#000000',
    contactIconColor: '#000000',
    contactDataColor: '#473bf5',
    locationTextColor: '#ffffff',
    locationIconColor: '#000000',
    locationBgColor: '#473bf5',
    socialProfilesHeadingColor: '#000000',
    saveAsImageButtonBgColor: '#473bf5',
    saveAsImageButtonTextColor: '#ffffff',
    saveToContactButtonBgColor: '#473bf5',
    saveToContactButtonTextColor: '#ffffff'
  },
  reducers: {
    setProfileField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setProfileImage(state, action) {
      state.files[0] = action.payload
    },
     toggleHideAddress(state) {
      state.isHideAddress = !state.isHideAddress
    },
    initializeProfile(state, action) {
      state.fullName = 'Cyril M Gupta'
      state.files = []
      state.phone = '+00-35353673456'
      state.email = 'example@gmail.com'
      state.website = 'www.teknikforce.com'
      state.company = 'Teknikforce Ventures LLC'
      state.job = 'CEO'
      state.isHideAddress= true
      state.fontFamily = 'Arial, sans-serif'
      state.cardColor = '#ffffff'
      state.nameColor = '#000000'
      state.jobCompanyColor = '#000000'
      state.contactDivBgColor = '#eaedff'
      state.contactHeadingColor = '#000000'
      state.contactIconColor = '#000000'
      state.contactDataColor = '#473bf5'
      state.locationTextColor = '#ffffff'
      state.locationIconColor = '#000000'
      state.locationBgColor = '#473bf5'
      state.socialProfilesHeadingColor = '#000000'
      state.saveAsImageButtonBgColor = '#473bf5'
      state.saveAsImageButtonTextColor = '#ffffff'
      state.saveToContactButtonBgColor = '#473bf5'
      state.saveToContactButtonTextColor = '#ffffff'
    }
  }
})

export const {
  setProfileField,
  setProfileImage,
  initializeProfile,
  toggleHideAddress,
} = profileSlice.actions
export default profileSlice.reducer